import { MediaLabel, PlayStatus } from '../../learnware/LearnwareEnums';
export class AskingProgress {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get asking() {
        return this.parent;
    }
    get app() {
        return this.asking.app;
    }
    get hatRueckmeldungErhalten() {
        return (this.asking.askingMedia.relevantIntents.filter(intent => [MediaLabel.questioncorrect, MediaLabel.questionwrong, MediaLabel.questioncomplete].includes(intent.mediumLabel) &&
            [PlayStatus.Ended, PlayStatus.Aborted].includes(intent.playStatus)).length > 0);
    }
}
